/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    dash: {
      type: Boolean,
      default: true
    },
    solid: {
      type: Boolean,
      default: false
    }
  }
};